export const createEditDistributionForm = id => `configDistributionEditForm${id}`;